import { initTournamentFilters } from "../helpers/tournamentFilters.js";

initTournamentFilters();